import { DtoBase } from "UvExplorerServer.Dtos.TS";


export class SlackSettings extends DtoBase {

    public Webhooks: string;

    constructor() {
        super();

        this.Webhooks = "";
    }

    public get HasWebhooks(): boolean {
        return !!this.Webhooks;
    }

    public get IsValid(): boolean {
        return (this.HasWebhooks);
    }

	public Write(obj: any, context: any): void {
		obj.slack_settings = {};
		obj = obj.slack_settings;

		super.Write(obj, context);

        if (this.HasWebhooks) {
            obj.webhooks = this.Webhooks;
        }
	}

	public Read(obj: any, context: any): void {

		if (!obj.slack_settings)
			throw new Error();
		obj = obj.slack_settings;

		super.Read(obj, context);

        if (obj.webhooks !== undefined)
            this.Webhooks = obj.webhooks;
	}

}